import type { JobType } from "@repo/app-types/entities/jobType";
import {
  SimpleSelect,
  type SimpleSelectOption,
} from "@repo/ui/Select/simpleSelect";
import type { FC } from "react";
import { useAllJobTypesQuery } from "../../api/entities/jobType.js";

export interface JobTypePickerProps {
  jobTypeId: string | null;
  onChange: (jobType: JobType | null) => void;
}

export const JobTypePicker: FC<JobTypePickerProps> = ({
  jobTypeId,
  onChange,
}) => {
  const { data: allJobTypes, isLoading } = useAllJobTypesQuery();

  const options: readonly SimpleSelectOption<string>[] = [
    { label: "New job type", value: "new" },
    ...(allJobTypes?.map((jobType) => ({
      label: jobType.name,
      value: jobType.id,
    })) ?? []),
  ];

  return (
    <div className="relative">
      <SimpleSelect
        options={options}
        value={jobTypeId ?? "new"}
        onChange={(value) => {
          if (value === "new") {
            onChange(null);
          } else {
            const jobType = allJobTypes?.find((jt) => jt.id === value);
            onChange(jobType ?? null);
          }
        }}
        label="Job type"
        isDisabled={isLoading}
        placeholder={isLoading ? "Loading job types..." : "New job type"}
      />
    </div>
  );
};
